import React from "react";
import "./Home.css";
import { SubmissionButton } from "../SumbissionButton";
import { Profile } from "../Profile";

export const ResearchCalls = () => {
  const submitButton = {
    title: "Research Paper",
    url: "https://edas.info/N33044",
  };

  const profilesProgramme = [
    {
      title: "Prof",
      firstName: "Siobhán",
      surname: "Clarke",
      university: "Trinity College Dublin",
      bio: "https://www.scss.tcd.ie/siobhan.clarke/",
      image: "./images/profiles/Clarke.jpg",
      linkedin:
        "https://www.linkedin.com/in/siobhan-clarke-59b0132/?originalSubdomain=ie",
      //twitter: "https://x.com/sclarketcd?lang=en",
      email: "siobhan.clarke@tcd.ie",
    },
    {
      title: "Dr",
      firstName: "Franca",
      surname: "Delmastro",
      university: "CNR, Italy",
      bio: "http://cnd.iit.cnr.it/fdelmastro/",
      image: "./images/profiles/franca.png",
      linkedin:
        "https://www.linkedin.com/in/francadelmastro/?originalSubdomain=it",
      email: "franca.delmastro@iit.cnr.it",
    },
  ];

  return (
    <div className="page-layout">
      <div className="text-layout">
        <p style={{ fontWeight: "bold", textAlign: "center" }}>
          *** Accepted Posters, Demos, and WIP papers will be published on IEEE
          Xplore! ***
        </p>
        <SubmissionButton props={submitButton} className="submit-button" />
        <h2>Call for Research Papers</h2>
        <p>
          SMARTCOMP 2025, the 11th edition of the premier conference on smart
          computing, will be held in Cork, Ireland from 16th to 19th June 2025.
        </p>
        <p>
          Smart computing is a multidisciplinary domain based on the synergistic
          influence of advances in sensor-based technologies, Internet of
          Things, cyber-physical systems, edge computing, big data analytics,
          machine learning, cognitive computing, ambient intelligence, and
          artificial intelligence.
        </p>
        <p>
          Applications of smart computing can be found in various societal
          domains, including transportation, energy, environmental protection,
          smart and connected communities, healthcare, industrial systems, and
          entertainment. Algorithmic and systems advancements of cloud
          computing, mobile and pervasive computing, sensor networking, and
          social computing are taking smart computing to a new level while
          improving our ways of living.
        </p>
        <p>
          SMARTCOMP 2025 welcomes novel, cutting-edge and creative research
          contributions. Authors are encouraged to discuss the importance,
          timeliness, and significance of their work as well as limitations,
          future opportunities and open research directions.
        </p>
        <h3>Main Research Track</h3>
        <p>
          SMARTCOMP 2025 solicits submissions that address the core challenges
          of smart computing, focusing on designing and developing scalable,
          dependable systems, and leveraging computing technologies to enhance
          resource sustainability and elevate the quality of human life.
        </p>
        <p>
          {" "}
          Topics of interest include – but are not limited to – the following:
        </p>
        <ul>
          <li>Emerging Smart Computing Paradigms</li>
          <li>Algorithms for Smart Computing</li>
          <li>AI and Machine Learning in Smart Computing</li>

          <li>
            Mobile and Ubiquitous Smart Systems, Wearable Computing and IoT
          </li>
          <li>Intelligent Cyber-Physical Systems</li>
          <li>Cloud, Edge, and Fog based Smart Computing Platforms</li>
          <li>Data Architectures and Analytics for Smart Computing</li>
          <li>Distributed Sensing, AI, and Computation</li>
          <li>Middleware for Smart Systems</li>

          <li>Novel Communication Paradigms in Smart Computing</li>
          <li>Low Power Communication and Computing for Smart Systems</li>
          <li>Social Computing and Smart Systems</li>
          <li>Quantum Computing in Smart Systems</li>
          <li>Security, Privacy, and Trust in Smart Computing</li>
          <li>Fairness and Socio-technical Aspects of Smart Computing</li>
          <li>Interdisciplinary Approaches to Smart Computing</li>
          <li>
            Novel applications of Smart Computing in emerging and high potential
            fields (e.g. Smart Communities, Health, Industry, Transport, Energy,
            Agrifood, ...)
          </li>
        </ul>
        <h3 style={{ marginTop: "30px" }}>Important Dates</h3>
        <p>
          Paper Submission:{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            23rd February 2025
          </span>{" "}
          <span
            style={{
              fontWeight: "bold",
              color: "blue",
              textDecoration: "line-through",
            }}
          >
            9th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            16th March 2025 (firm)
          </span>
        </p>
        <p>
          Acceptance Notification:{" "}
          <span style={{ fontWeight: "bold" }}>10th April 2025</span>
        </p>{" "}
        <p>
          Camera Ready (tentative):{" "}
          <span style={{ fontWeight: "bold" }}>10th May 2025</span>
        </p>{" "}
        <p>
          Conference:{" "}
          <span style={{ fontWeight: "bold" }}>16 to 19 June 2025</span>
        </p>{" "}
        <p>All deadlines are Anywhere on Earth.</p>{" "}
        <h3>Submission Guidelines</h3>
        <p>
          Paper submissions must be no longer than 8 pages (the page count limit
          includes the references list) and formatted according to the
          two-column IEEE proceedings template. All submitted papers that
          conform to these guidelines will be subject to peer reviews by
          Technical Program Committee members and other experts in the field.
          All presented papers will be published in the conference proceedings
          and submitted to the IEEEXplore Digital Library.
        </p>
        <p>
          Since the conference will be an entire in-presence event, no virtual
          or remote presentation will be allowed.
        </p>
        <p>
          Accepted papers must be presented in person by one of the authors, in
          addition to having an associated full registration. Failure to comply
          with this requirement will result in the exclusion of the paper from
          the final proceedings, the conference program and from the IEEE
          Digital Library.
        </p>
        <p>
          We also strongly advise authors of submitted papers to be prepared to
          apply for their Irish visa, if required, as soon as their paper is
          accepted.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>
            The conference applies a single-blind review process.
          </span>
        </p>{" "}
        <p style={{ fontWeight: "bold", textAlign: "center" }}>
          *** Accepted Posters, Demos, and WIP papers will be published on IEEE
          Xplore! ***
        </p>
        <SubmissionButton props={submitButton} />
        <p style={{ marginTop: "20px" }}>
          Paper registration will open on November 1 st , 2024
        </p>
        <p>
          One additional page for the camera ready version can be purchased
          after the paper review and selection.
        </p>
        <hr />
        <h3>BEST PAPER AWARD and Editorial Follow-Ups</h3>
        <p>
          The authors of the best paper will receive an award to recognize their
          outstanding contribution to the field. In addition, extended versions
          of selected high-quality papers accepted to the main conference will
          be considered for publication in{" "}
          <a href="https://www.sciencedirect.com/journal/pervasive-and-mobile-computing">
            Elsevier’s Pervasive and Mobile Computing journal (IF: 4.3)
          </a>
        </p>
        <h3>Technical Program Committee Co-Chairs</h3>
        <div>
          {profilesProgramme.map(function (data) {
            return <Profile props={data} />;
          })}
        </div>
        <h3>Contact Information</h3>
        <p>
          For any questions about the conference, please contact the TPC
          Co-Chairs at:
          <a href="mailto:smartcomp2025@iit.cnr.it">smartcomp2025@iit.cnr.it</a>
        </p>
      </div>
    </div>
  );
};
